import React, { useRef } from 'react'
import jsonpath from 'jsonpath'
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
const PokaYokeSheet = ({obj, data, company }) => {
    const keys = Object.keys(data);

    const customerRef = useRef([]);
    function extractData(json, path) {
        if (json) {
            const result = jsonpath.query(json, path);
            return result;
        }
        return ""
    }
    const getDaysInCurrentMonth = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // getMonth() returns 0-11, so add 1 to get 1-12
        return new Date(year, month, 0).getDate(); // Passing 0 as the day returns the last day of the previous month
    };
    const timestamp = '2024-09-03T06:30:30.366Z';
    const day = (new Date(timestamp)).getDate();
    const demoFromHTML = async (key) => {
        const source = customerRef.current[key];
        // Wait for all images in the source element to be loaded
        const loadImages = () => {
            const images = source.getElementsByTagName('img');
            const promises = Array.from(images).map((img) => {
                return new Promise((resolve) => {
                    if (img.complete) {
                        resolve();
                    } else {
                        img.onload = resolve;
                        img.onerror = resolve; // Resolve in case of an error as well
                    }
                });
            });
            return Promise.all(promises);
        };
        // Wait for images to load
        await loadImages();
        const table = source.querySelector('table'); // Target the table element
        const rows = Array.from(table.querySelectorAll('tr')); // Get all rows of the table
        const maxRowsPerPage = 25; // Set 25 rows per page
        const totalRows = rows.length;
        const numPages = Math.ceil(totalRows / maxRowsPerPage); // Calculate the number of pages needed
        const pdf = new jsPDF('landscape', 'pt', 'a4',true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const margin = 20;
        const marginWidth = margin;
        const marginHeight = margin;
        const availableWidth = pdfWidth - 2 * marginWidth;
        const availableHeight = pdfHeight - 2 * marginHeight;
        for (let page = 0; page < numPages; page++) {
            const canvas = await html2canvas(source, { scale: 2 });
            // Get only the rows for the current page (25 rows per page)
            const startRow = page * maxRowsPerPage;
            const endRow = Math.min((page + 1) * maxRowsPerPage, totalRows);
            const currentRows = rows.slice(startRow, endRow);
            // Temporarily hide rows not belonging to the current page
            rows.forEach((row, index) => {
                row.style.display = index >= startRow && index < endRow ? '' : 'none';
            });
            // Re-render the canvas for the current page's content
            const canvasForPage = await html2canvas(source, { scale: 2 });
            const imgData = canvasForPage.toDataURL('image/jpeg', 0.7);
            const imgHeight = (canvasForPage.height * availableWidth) / canvasForPage.width;
            const position = marginHeight;
            // Add content to the PDF for the current page
            pdf.addImage(
                imgData,
                'JPEG',
                marginWidth,
                position,
                availableWidth,
                imgHeight > availableHeight ? availableHeight : imgHeight
            );
            if (page < numPages - 1) {
                pdf.addPage(); // Add a new page if it's not the last one
            }
        }
        // Restore all rows to be visible after generating the PDF
        rows.forEach(row => (row.style.display = ''));
        pdf.save(`${obj.InspectionType}_${new Date(obj.DateTime).toLocaleString()}.pdf`);
    };

    const getShiftDataForDay = (data, pdf, rowIndex) => {
        return Array(getDaysInCurrentMonth()).fill().map((_, index) => {
          const currentDay = index + 1;
          
          // Find the correct start of shift entry for the current day
          const startOfShiftData = data[pdf] && data[pdf].length > 0 && data[pdf].find(item => {
            const shiftDay = new Date(extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0]).getDate();
            return item.customFields && 
              item.customFields.length >= 1 && 
              extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0] === 'Start Of Shift' &&
              shiftDay === currentDay;
          });
      
          const checksheetData = startOfShiftData?.Checksheet[rowIndex]?.Data[0];
          
          return (
            <th key={index} style={{ verticalAlign: 'middle' }} rowSpan={1}>
              {startOfShiftData ? 
                (checksheetData ? checksheetData.ResultLabel ? checksheetData.ResultLabel : checksheetData.Result : '-') :
                '-'}
            </th>
          );
        });
      };
      // Function to get the End Of Shift data for each day in the current month
const getEndOfShiftDataForDay = (data, pdf, rowIndex) => {
    return Array(getDaysInCurrentMonth()).fill().map((_, index) => {
      const currentDay = index + 1;
  
      // Find the correct end of shift entry for the current day
      const endOfShiftData = data[pdf] && data[pdf].length > 0 && data[pdf].find(item => {
        const shiftDay = new Date(extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0]).getDate();
        return item.customFields &&
          item.customFields.length >= 1 &&
          extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0] === 'End Of Shift' &&
          shiftDay === currentDay;
      });
  
      const checksheetData = endOfShiftData?.Checksheet[rowIndex]?.Data[0];
  
      return (
        <th key={index} style={{ verticalAlign: 'middle' }} rowSpan={1}>
          {endOfShiftData ? 
            (checksheetData ? checksheetData.ResultLabel ? checksheetData.ResultLabel : checksheetData.Result : '-') : 
            '-'}
        </th>
      );
    });
  };
  const renderDays = (dataArray, pdf, shiftEvent) => {
    return Array.from({ length: getDaysInCurrentMonth() }, (_, index) => {
      const currentDay = index + 1;
      const shiftData =
        data[pdf]?.find((item) => {
          const shiftDay = new Date(extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0]).getDate();
          return (
            extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0] === shiftEvent &&
            shiftDay === currentDay
          );
        }) || {};

      const checksheetData = shiftData.DateTime;
      return (
        <th key={index} className="text-wrap text-center" style={{ verticalAlign: 'middle' }}>
          {checksheetData ? moment(checksheetData).format('hh:mm a') : '-'}
        </th>
      );
    });
  };

    return (
            <>
     {keys.sort((a, b) => a.localeCompare(b)) && keys.map((pdf,tableIndex)=>   <div>
            <button className="btn-sm btn-primary" onClick={()=>demoFromHTML(tableIndex)}>Download PDF</button>
            <div ref={(el) => customerRef.current[tableIndex] = el}>
                <table  id={''} className="table table-sm table-bordered table-hover small table-striped " style={{ padding: 0 }}>
                    <thead className='small text-center border'>
                        <tr className='text-center align-self-center '>
                            <th className='text-start fs-5' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}><img src={company.logo || ""} className='avatar' style={{ width: 150 }} /></th>
                            <th style={{ verticalAlign: 'middle' }} className='fs-6' rowSpan={1} colSpan={getDaysInCurrentMonth() - 4}>{
                                extractData(obj, '$..customFields[?(@.FieldName=="Line Number")].Value')}</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={8}> MONTH - {obj.DateTime ? moment(obj.DateTime).format('MMM , YYYY') : '-'} {'/ shift :'+ pdf ?? '-'}</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Poka Yoke No.</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4} >M/C Name & No.</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Poka Yoke Type</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Purpose</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4} >How to Check</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Checking Point</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1} ></th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={getDaysInCurrentMonth()}>DATE</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                        <th style={{ verticalAlign: 'middle' }} rowSpan={1} ></th>
                        
                            {Array(getDaysInCurrentMonth()).fill().map((_, index) => <th style={{ verticalAlign: 'middle' }} rowSpan={1} >{index + 1}</th>)}
                        </tr>
                        <tr className='text-center align-self-center '>
                        <th style={{ verticalAlign: 'middle' }} rowSpan={1} >Start Of Shift (time)</th>
                        {renderDays(data[pdf], pdf, 'Start Of Shift')}
                        {/* {Array(getDaysInCurrentMonth()).fill().map((_, index) => {
                                    const currentDay = index + 1;
                                  // Find the correct start of shift entry for the current day
                                    const startOfShiftData = data[pdf] && data[pdf].length > 0 && data[pdf].find(item => {
                                        const shiftDay = new Date(extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0]).getDate();
                                        return item.customFields && 
                                        item.customFields.length >= 1 && // Ensure at least two elements exist
                                            //    item.customFields[1]?.Value === 'Start Of Shift' && 
                                            extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0]=='Start Of Shift'&&
                                            
                                            shiftDay === currentDay;
                                        });
                                        
                                    const checksheetData = startOfShiftData?.DateTime
                                    return (
                                        <th  className="text-wrap"  key={index} style={{ verticalAlign: 'middle' }} rowSpan={1}>
                                            {startOfShiftData ?
                                                (checksheetData ? moment(checksheetData).format('hh:mm a'): '-') :
                                                '-'}
                                        </th>
                                    );
                                })} */}
                        </tr>
                        <tr  className='text-center align-self-center '>
                        <th style={{ verticalAlign: 'middle' }} rowSpan={1} >End Of Shift (time)</th>
                        {renderDays(data[pdf], pdf, 'End Of Shift')}
                        {/* {Array(getDaysInCurrentMonth()).fill().map((_, index) => {
                                        const currentDay = index + 1;
                                        
                                        // Find the correct end of shift entry for the current day
                                        const endOfShiftData = data[pdf] && data[pdf].length > 0 && data[pdf].find(item => {
                                        const shiftDay = new Date(extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0]).getDate();
                                        return item.customFields && 
                                        item.customFields.length >= 1 && 
                                        extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0]=='End Of Shift'&&
                                        
                                        // item.customFields[1].Value === 'End Of Shift' &&
                                         shiftDay === currentDay;
                                    });
                                    const checksheetData = endOfShiftData?.DateTime


                                    return (
                                        <th className="text-wrap" key={index} style={{ verticalAlign: 'middle' }} rowSpan={1}>
                                                {endOfShiftData ?
                                                (checksheetData ? moment(checksheetData).format('hh:mm a') : '-') :
                                                '-'}
                                            </th>
                                        );
                                    })} */}
                        </tr>
                        
                    </thead>
                    <tbody>
                        {console.log(data,"gugyugyu",pdf)}
                        {data[pdf] && data[pdf].length > 0 && data[pdf][0].Checksheet.map((one, rowIndex) => (
                            <React.Fragment key={rowIndex}>
                                <tr>
                                   <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.Poka_Yoke_No}</th>
                                    <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.MC_Name__No}</th>
                                    <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.PokaYoke_Type}</th>
                                    <th rowSpan={2} style={{ fontWeight: '400' }} className="text-center">{one.Purpose}</th>
                                    <th rowSpan={2} className="text-center" style={{ fontWeight: '400' }}>{one.How_To_Check}</th>
                                    <th rowSpan={2} className="text-center" style={{ fontWeight: '400' }}>{one.Checking_Point}</th>
                                 {/* Start of Shift */}
                                 <th rowSpan={1} className="text-center" style={{ fontWeight: '400' }}>Start of Shift</th>
                                 {getShiftDataForDay(data, pdf, rowIndex)}
                                {/* {Array(getDaysInCurrentMonth()).fill().map((_, index) => {
                                    const currentDay = index + 1;
                                  // Find the correct start of shift entry for the current day
                                    const startOfShiftData = data[pdf] && data[pdf].length > 0 && data[pdf].find(item => {
                                        const shiftDay = new Date(extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0]).getDate();
                                        return item.customFields && 
                                        item.customFields.length >= 1 && // Ensure at least two elements exist
                                            //    item.customFields[1]?.Value === 'Start Of Shift' && 
                                            extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0]=='Start Of Shift'&&
                                            
                                            shiftDay === currentDay;
                                        });
                                        
                                    const checksheetData = startOfShiftData?.Checksheet[rowIndex]?.Data[0];
                                    return (
                                        <th key={index} style={{ verticalAlign: 'middle' }} rowSpan={1}>
                                            {startOfShiftData ?
                                                (checksheetData ? checksheetData.ResultLabel?checksheetData.ResultLabel:checksheetData.Result : '-') :
                                                '-'}
                                        </th>
                                    );
                                })} */}
                            </tr>
                                {/* End of Shift */}
                                <tr>
                                    <th rowSpan={1} className="text-center" style={{ fontWeight: '400' }}>End Of Shift</th>
                                    {getEndOfShiftDataForDay(data, pdf, rowIndex)}
                                   
                                    {/* {Array(getDaysInCurrentMonth()).fill().map((_, index) => {
                                        const currentDay = index + 1;
                                        
                                        // Find the correct end of shift entry for the current day
                                        const endOfShiftData = data[pdf] && data[pdf].length > 0 && data[pdf].find(item => {
                                        const shiftDay = new Date(extractData(item, '$..customFields[?(@.FieldName=="Date_Shift")].Value')[0]).getDate();
                                        return item.customFields && 
                                        item.customFields.length >= 1 && 
                                        extractData(item, '$..customFields[?(@.FieldName=="Shift Event")].Value')[0]=='End Of Shift'&&
                                        
                                        // item.customFields[1].Value === 'End Of Shift' &&
                                         shiftDay === currentDay;
                                    });
                                    const checksheetData = endOfShiftData?.Checksheet[rowIndex]?.Data[0];
                                    return (
                                        <th key={index} style={{ verticalAlign: 'middle' }} rowSpan={1}>
                                                {endOfShiftData ?
                                                (checksheetData ? checksheetData.ResultLabel?checksheetData.ResultLabel:checksheetData.Result : '-') :
                                                '-'}
                                            </th>
                                        );
                                    })} */}
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                    <tfoot className='small text-center border'>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-center ' colSpan={6}>Sign (Q.A)</td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={32}>{extractData(obj, '$..customFields[?(@.FieldName=="QA Personnel")].Value')}</td>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={3}>U/I Under Implementation</td>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={2}>NP: No Production</td>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={1}>OK</td>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={1}>Not Ok </td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={31}> Note :- Poka yoke need to verified during Petrol Inspection</td>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} colSpan={2}> Note </td>
                            <td className="text-start" colSpan={31 + 5}> 1. Poka yoke need to verified during Petrol Inspection <br />
                                2. If Poka-Yoke not working stop the machine and inform to supervisor <br />
                                3. Incase of line run without poka-yoke, deviation will be raise and get it approval from Quality Head / Plant Manager and additional control to be implemente.
                            </td>
                        </tr>
                         <tr className='text-center align-self-center '>
                        
                        <td className='text-start' colSpan={38}>FMT-QAD-47, Rev-0 Dated-28-05-2014</td>
                    
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>)}
                        </>
    )
}
export default PokaYokeSheet